/* eslint-disable no-unused-vars */
// Klaro! consent manager configuration for HEIST.
// Loaded before {{ghost_head}} so consent state is set before any analytics
// scripts evaluate. See docs/gdpr/cookie-consent.md for the matching Code
// Injection snippet that pastes into Ghost Admin > Settings > Code injection
// > Site Header.
//
// Library: Klaro! v0.7 (BSD-3) — assets/js/klaro/klaro-no-css.js
// Build output: built/klaro.js (config + library concatenated; see gulpfile.js)

(function () {
    window.klaroConfig = {
        version: 1,
        elementID: 'klaro',
        storageMethod: 'cookie',
        cookieName: 'klaro',
        cookieExpiresAfterDays: 365,

        // Services default to off; user must opt-in (§ 25 TDDDG, BGH I ZR 7/16).
        default: false,
        // Show a bottom notice rather than a blocking modal. The notice still
        // includes a Reject button visually equal to Accept (EDPB 05/2020).
        mustConsent: false,
        acceptAll: true,
        hideDeclineAll: false,
        htmlTexts: true,

        translations: {
            en: {
                consentNotice: {
                    title: 'Cookies and analytics',
                    description:
                        '<em>HEIST</em> uses essential cookies and, with your consent, analytics. You can withdraw any time via Cookie Preferences. See our <a href="/impressum-imprint/">privacy policy</a>.',
                    changeDescription: 'Cookie settings have changed since your last visit.',
                    learnMore: 'Manage settings',
                },
                consentModal: {
                    title: 'Cookie Preferences',
                    description:
                        'Choose which cookies and similar storage <em>HEIST</em> may use on your device. Essential items are always on; analytics requires your consent and can be withdrawn at any time.',
                },
                purposes: {
                    analytics: {
                        title: 'Analytics',
                        description:
                            'Helps us understand which articles readers find useful. See each service below for what specifically is collected and where it goes.',
                    },
                    essential: {
                        title: 'Essential',
                        description:
                            'Cookies and storage needed for the site to function — member sign-in, payments, on-site search, and your consent choice. See our <a href="/impressum-imprint/">privacy policy</a> for the full list of processors.',
                    },
                },
                acceptAll: 'Accept all',
                acceptSelected: 'Accept selected',
                decline: 'Reject all',
                ok: 'Accept all',
                save: 'Save preferences',
                close: 'Close',
                poweredBy: 'Consent managed with Klaro!',
                service: {
                    disableAll: {
                        title: 'Enable or disable all services',
                        description: 'Use this switch to enable or disable all services at once.',
                    },
                    optOut: {
                        title: '(opt-out)',
                        description: 'This service is loaded by default but you can opt out.',
                    },
                    required: {
                        title: 'always required',
                        description: 'This service is strictly necessary and cannot be disabled.',
                    },
                    purposes: 'Purposes',
                    purpose: 'Purpose',
                },
                'google-analytics': {
                    description:
                        'Anonymised page-view statistics. Sets _ga / _ga_* cookies; transmits IP and client ID to Google LLC (US) under the EU-US Data Privacy Framework.',
                },
                'ghost-stats': {
                    description:
                        "Ghost's first-party analytics. Writes to localStorage; data stays with Ghost(Pro) servers.",
                },
                essential: {
                    title: 'Essential cookies',
                },
            },
        },

        services: [
            {
                name: 'google-analytics',
                title: 'Google Analytics 4',
                purposes: ['analytics'],
                cookies: [/^_ga/i, /^_gid/i, 'IDE'],
                callback: function (consent) {
                    if (typeof window.gtag !== 'function') return;
                    window.gtag('consent', 'update', {
                        analytics_storage: consent ? 'granted' : 'denied',
                    });
                },
            },
            {
                name: 'ghost-stats',
                title: 'Ghost first-party analytics',
                purposes: ['analytics'],
                cookies: [],
                // ghost-stats writes to localStorage, not cookies. Klaro cannot
                // unload it on Ghost(Pro) because the script is injected by
                // Ghost itself. We declare it for transparency; the localStorage
                // entries are cleared on Decline via the callback below.
                callback: function (consent) {
                    if (consent) return;
                    try {
                        Object.keys(window.localStorage || {})
                            .filter(function (k) {
                                return /^ghost-stats/i.test(k);
                            })
                            .forEach(function (k) {
                                window.localStorage.removeItem(k);
                            });
                    } catch (e) {
                        // localStorage unavailable (private mode etc.)
                    }
                },
            },
            {
                // Umbrella entry for strictly-necessary cookies. We do NOT
                // enumerate the processors here (Stripe, Portal, jsDelivr,
                // Ghost session, the klaro cookie itself) — those live in
                // the privacy policy under Art. 13(1)(e) GDPR. The toggle is
                // shown so readers see the category exists and is always on.
                name: 'essential',
                purposes: ['essential'],
                cookies: [],
                required: true,
            },
        ],
    };
})();
